export default {
  login: {
    name1: '欢迎登录溧电云物联网平台',
    name2: '请输入邮箱',
    name3: '请输入密码',
    name4: '请输入验证码',
    name5: '记住我',
    name6: '忘记密码？',
    name7: '登录',
    name8: '获取演示账号',
    name9: '返回正式版',
    name10: '注册体验版',
    name11: '溧水电子研究所@ 2025 Listek',
    name12: '登录ListekIOT体验版',
    name13: '演示账号',
    name14: '账号名称',
    name15: '演示网站 ',
    name16: '账号',
    name17: '密码',
    name18: '一键登录',
    name19: '立即登录',
    name20: '账号：',
    name21: '密码：',
    name22: '忘记密码',
    name23: '请输入登录名称',
  },
  register: {
    name1: '返回正式版',
    name2: '注册ListekIOK体验版',
    name3: '请输入企业名称',
    name4: '请输入邮箱',
    name5: '请输入验证码',
    name6: '获取验证码',
    name7: '请输入密码',
    name8: '再次输入密码',
    name9: '阅读',
    name10: '隐私条款',
    name11: '立即注册',
    name12: '已有账号,立即登录',
    name13: '溧水电子研究所@ 2025 Listek',
    name14: '注册成功!',
  },
  retrievePassword: {
    name1: '返回',
    name2: '找回密码',
    name3: '请输入邮箱',
    name4: '请输入验证码',
    name5: '获取验证码',
    name6: '请输入密码',
    name7: '再次输入密码',
    name8: '提交',
    name9: '获取演示账号',
    name10: '溧水电子研究所@ 2025 Listek',
    name11: '请输入手机号码',
    name12: '发送验证码',
    name13: '重新发送',
    name14: '请再次输入密码',
    name15: '两次输入密码不一致!',
    name16: '手机号码格式不正确',
    name17: '请输入邮箱格式',
    name18: '邮箱格式不正确',
    name19: '请输⼊至少6位密码',
    name20: '密码必须同时包含数字和字母',
  },

  tabmenu: {
    name1: '首页',
    name2: '车辆',
    name3: '车辆升级',
    name4: '历史可视化报告',
    name5: '有线升级工具',
    name6: 'OTA管理',
    name7: '车辆管理',
    name8: '车辆列表',
    name9: '车型列表',
    name10: '固件升级记录',
    name11: '故障管理',
    name12: '财务',
    name13: '设备IoT收费',
    name14: 'SIM卡管理',
    name15: '运营',
    name16: 'app运营',
    name17: 'app上架总览',
    name18: 'app用户总览',
    name19: '管理',
    name20: '系统用户管理',
    name21: '系统用户列表',
    name22: '系统用户角色',
    name23: '权限规则',
    name24: '系统日志管理',
    name25: '厂商用户管理',
    name26: '厂商名单列表',
    name27: '厂商用户列表',
    name28: '商户用户管理',
    name29: '商户名单列表',
    name30: '商户用户列表',
    name31: '加盟商名单列表',
    name32: '加盟商用户列表',
    name33: '系统通知',
    name34: '设置',
    name35: '权限范围',
    name36: '厂商用户角色',
    name37: '商户用户角色',
    name38: '骑行列表',
    name39: '路书列表',
    name40: '骑行管理',
    name41: 'IOT列表',
    name42: '反馈列表',
    name43: '商户购车订单',
    name44: '三类商户系统介绍',
    name45: '推送列表',
    name46: '加盟商用户角色',
    name47: '可视化报告',
    name48: '车辆分析',
    name49: '数据总览',
    name50: '激活数据',
    name51: '报告详情',
    name52: '电子围栏',
    name53: '车辆运营',
    name54: '出入对账',
    name55: '批量升级',
    name56: '实时监控',
    name57: '使用情况',
    name58: '故障统计',
    name59: '地区分布',
    name60: 'App配置',
    name61: '交易记录',
    name62: '退款记录',
    name63: '数据汇总',
    name64: 'App分析',
    name65: 'App情况',
    name66: '产品质量合格证',
    name67: '车型汇总',
    name68: '维修记录',
    name69: '销售记录',
    name70: '系统配置管理',
    name71: '演示账号管理',
    name72: '厂商客服配置',
  },

  notification: {
    empty: '暂无通知',
    emptyHint: '仅展示最近 1 小时内的未读广播消息',
    loadError: '通知加载失败，请稍后重试',
    defaultTitle: '系统通知',
    batteryHighTitle: '车辆高温告警',
    batteryHighContent: '车辆 {ebikeId} 触发高温告警！',
    ebikePostureTitle: '车辆震动报警',
    ebikePostureContent: '车辆 {ebikeId} 触发震动报警！',
    noticeMsgTitle: '通知消息',
    cycleFallTitle: '车辆侧翻警报',
    cycleFallContent: '车辆 {ebikeId} 触发侧翻警报！',
    fenceWarnTitle: '围栏告警',
    fenceWarnContent: '车辆 {ebikeId} 触发围栏告警！',
    feedbackReplyTitle: '反馈回复',
    ebikeFaultTitle: '车辆故障告警',
    ebikeFaultContent: '车辆 {ebikeId} 发生故障告警！',
    offLineTitle: '车辆离线告警',
    offLineContent: '车辆 {ebikeId} 已离线！',
    genericVehicleContent: '车辆 {ebikeId} 发生告警'
  },

  home: {
    name1: '查看明细',
    name2: '厂商数量',
    name3: '使用溧电IOT商户数量',
    name4: '商户数量',
    name5: '设备IOT累计收费',
    name6: '户',
    name7: 'IOT设备新增趋势',
    name8: '故障情况',
    name9: '故障处理情况',
    name10: 'SIM卡使用情况',
    name11: 'IOT累计数量/个',
    name12: '本月新增',
    name13: '激活累计数量/个',
    name14: '故障累计数量/件',
    name15: 'SIM卡累计流量/M',
    name16: '厂商累计数量/户',
    name17: '商户累计数量/户',
    name18: 'IOT新增数量',
    name19: 'IOT激活数量',
    name20: 'TOP5厂商',
    name21: '厂商/商户',
    name22: 'TOP5商户',
    name23: '全部车辆',
    name24: '在线车辆',
    name25: '故障车辆',
    name26: '电量',
    name27: '车辆状态',
    name28: '已解锁',
    name29: '已上锁',
    name30: '正在使用',
    name31: '账户信息',
    name32: '修改密码',
    name33: '账号归属：',
    name34: '本次登录：',
    name35: '登录地区：',
    name36: '上次登录：',
    name37: '原始密码：',
    name38: '车辆温度过高',
    name39: '用户总数',
    name40: 'App在线总人数',
    name41: 'App离线总人数',
    name42: '最新注册的App用户',
    name51: '溧电',
    name52: '厂商版',
    name53: '共享版',
    name54: '租赁版',
    name55: '销售版',
    name56: '共享加盟商版',
    name57: '租赁加盟商版',
    name58: '销售加盟商版',
    name59: '车辆温度过高实时预警',
    name60: '请输入原始密码',
    name61: '厂商新增趋势',
    name62: '新增数量',
    name63: '故障新增趋势',
    name64: '故障数量',
    name65: '流量使用趋势',
    name66: '激活数量',
    name67: '商户新增趋势',
    name68: '故障',
    name69: '上一辆',
    name70: '下一辆',
    name71: '账号名：',
    name72: '电机状态',
    name73: '电池状态',
    name74: '控制器状态',
    name75: '传感器状态',
    name76: '电机系统',
    name77: '控制器系统',
    name78: 'BMS系统',
    name79: 'BMS系统1',
    name80: 'IOT总数量',
    name81: '台',
  },
  bike: {
    name1: '厂商名称：',
    name2: '车型编号：',
    name3: '添加车辆',
    name4: '车型编号',
    name5: '厂商名称',
    name6: '报告时间',
    name7: '速度',
    name8: '高度',
    name9: '控制器电压',
    name10: '控制器电流',
    name11: '操作',
    name12: '查看',
    name13: '删除',
    name14: '控制器',
    name15: '显示',
    name16: '电池',
    name17: '端口号：',
    name18: '文件名：',
    name19: '立即升级',
    name20: '类型：',
    name21: '版本号：',
    name22: '文件ID',
    name23: '车型编号',
    name24: '版本号',
    name25: '文件名',
    name26: '类型',
    name27: '大小',
    name28: '文件路径',
    name29: '创建时间',
    name30: '商户名称：',
    name31: '控制器版本号：',
    name32: '仪表版本：',
    name33: 'IOT版本：',
    name34: '车型编号：',
    name35: '车辆状态：',
    name36: '添加IOT编号',
    name37: '导入IOT编号',
    name38: 'IOT编号',
    name39: '厂商>商户名称',
    name40: '车辆MAC',
    name41: 'IOT编号',
    name42: '绑定用户账号',
    name43: '控制器版本',
    name44: '测试机',
    name45: '正常',
    name46: '详情',
    name47: '编辑',
    name48: '车型名称：',
    name49: '电机型号：',
    name50: '电池信号：',
    name51: '车辆id',
    name52: '车型名称',
    name53: '车架颜色',
    name54: '电机型号',
    name55: '电池电压',
    name56: '电池电流',
    name57: '车胎',
    name58: '版本型号：',
    name59: '版本类型：',
    name60: '升级类型',
    name61: '版本类型',
    name62: '版本型号',
    name63: '升级状态',
    name64: '升级时间',
    name65: 'IOT编号：',
    name66: '骑行编号：',
    name67: '故障状态：',
    name68: '故障类型：',
    name69: '上报时间：',
    name70: '骑行编号',
    name71: '故障类型',
    name72: '故障状态',
    name73: '上报时间',
    name74: '故障详情',
    name75: '创建人编号',
    name76: '修改人编号 ',
    name77: '修改时间 ',
    name78: '审核人编号 ',
    name79: '故障描述',
    name80: '故障图片',
    name81: '暂无图片信息',
    name82: '报告详情',
    name83: '基本信息',
    name84: '报告时间：',
    name85: '其他信息',
    name86: '速度：',
    name87: '经纬度：',
    name88: '高度：',
    name89: '控制器电压：',
    name90: '控制器电流：',
    name91: '控制器温度：',
    name92: '转把电压：',
    name93: '电机功率：',
    name94: '踏频：',
    name95: '蓝牙连接情况：',
    name96: 'GPS连接情况：',
    name97: '仪表连接情况：',
    name98: 'IOT编号：',
    name99: '测试机：',
    name100: '模板下载：',
    name101: '模板下载',
    name102: '上传IOT编号：',
    name103: '上传附件',
    name104: '测试',
    name105: '商户名称',
    name106: '仪表版本',
    name107: 'IOT版本',
    name108: '车架五通编号',
    name109: '电机编号',
    name110: '备注',
    name111: '运输状态',
    name112: '状态',
    name113: '故障',
    name114: '解绑',
    name115: '绑定',
    name116: '导入五通码',
    name117: '运输模式',
    name118: '版本配置',
    name119: '分配运营商',
    name120: '车型绑定',
    name121: '行驶总里程：',
    name122: '最大功率：',
    name123: '最小功率：',
    name124: '最大电压：',
    name125: '最小电压：',
    name126: '最高速度：',
    name127: '控制器最高温度：',
    name128: '控制器最低温度：',
    name129: '故障时间',
    name130: '对应编码',
    name131: '故障定义',
    name132: '无位置信息',
    name133: '暂无故障数据',
    name134: '电压电流汇总',
    name135: '温度汇总',
    name136: '功率/速度汇总',
    name137: '控制器温度',
    name138: '电机温度',
    name139: '电池温度',
    name140: '功率百分比',
    name141: '速度',
    name142: '电池电压',
    name143: '电池电流',
    name144: '温度',
    name145: '报告开始时间：',
    name146: '添加报告',
    name147: '报告开始时间',
    name148: '报告结束时间',
    name149: '导出Excel数据',
    name150: '厂商：',
    name151: '报告结束时间：',
    name152: '电池型号：',
    name153: '电池型号',
    name154: '电池容量',
    name155: '传感器',
    name156: '分配归属',
    name157: '导入分配归属',
    name158: '导入IOT',
    name159: '导出车辆信息',
    name160: '厂商/商户/加盟商：',
    name161: '车辆详情',
    name162: '修改备注',
    name163: '车辆基本信息',
    name164: '车辆编码：',
    name165: '车辆mac：',
    name166: '入库时间：',
    name167: '轨迹时间：',
    name168: '心跳时间：',
    name169: '经度：',
    name170: '纬度：',
    name171: '高度：',
    name172: '控制器型号：',
    name173: '控制器温度偏移度：',
    name174: '控制器型号',
    name175: '控制器温度偏移度',
    name176: '传感器：',
    name177: '轮胎：',
    name178: '电池容量：',
    name179: '电池电流：',
    name180: '电池电压（V）：',
    name181: '电池型号：',
    name182: '电机型号：',
    name183: '车架颜色：',
    name184: '车型名称：',
    name185: '新增车型',
    name186: '车况图片：',
    name187: '设备管理图片：',
    name188: '厂商/商户：',
    name189: '导入车型',
    name190: '创建者名称',
    name191: '创建者编号',
    name192: '路书编号',
    name193: '创建时间',
    name194: '更新时间',
    name195: '起点',
    name196: '目的地',
    name197: '距离(m)',
    name198: '路书类型',
    name199: '个人路书',
    name200: '官方路书',
    name201: '难度系数',
    name202: '添加路书',
    name203: '起点地址：',
    name204: '终点地址：',
    name205: '距离：',
    name206: '难度系数：',
    name207: '路况：',
    name208: '消耗热量：',
    name209: '时间(min)：',
    name210: '封面：',
    name211: '轨迹集合：',
    name212: '导入车辆信息',
    name213: '导入产品质量合格证',
    name214: '生产信息',
    name215: '查看车辆信息',
    name216: '速度：',
    name217: '电量：',
    name218: '控制器温度：',
    name219: '电机温度：',
    name220: '电池温度：',
    name221: '电压：',
    name222: '电流：',
    name223: '车锁的状态：',
    name224: '解锁状态',
    name225: '锁车状态',
    name226: '状态：',
    name227: '故障',
    name228: '正常',
    name229: '车辆信息',
    name230: '车辆报警信息',
    name231: '发生时间',
    name232: '报警状态',
    name233: '已变化',
    name234: '未变化',
    name235: 'IOT版本号：',
    name236: 'IoT温度显示偏差值（℃）：',
    name237: 'IoT温度显示报警预设值（℃）：',
    name238: '控制器编号：',
    name239: '控制器温度显示偏差值（℃）：',
    name240: '控制器温度显示报警预设值（℃）：',
    name241: '电池版本号：',
    name242: '电池编号：',
    name243: '电池温度显示偏差值（℃）：',
    name244: '电池温度显示报警预设值（℃）：',
    name245: '电机版本号：',
    name246: '电机编号：',
    name247: '电机温度显示偏差值（℃）：',
    name248: '电机温度显示报警预设值（℃）：',
    name249: '仪表编号：',
    name250: '仪表版本号：',
    name251: '否',
    name252: '是',
    name253: '删除车辆',
    name254: 'IOT详情',
    name255: 'IOT基本信息',
    name256: '认证用户名：',
    name257: '连接状态：',
    name258: '端口：',
    name259: '节点：',
    name260: 'IP地址：',
    name261: '心跳：',
    name262: '会话创建时间：',
    name263: '会话过期时间：',
    name264: '连接时间：',
    name265: '发送报文数：',
    name266: '接收报文数：',
    name267: '接收的报文数量：',
    name268: '最大未确认的数据包计数：',
    name269: '最大飞行窗口：',
    name270: 'IOT订阅的主题',
    name271: 'IOT日志',
    name272: '车辆IOT编号',
    name273: '产品名称',
    name274: '车型编号',
    name275: '制造商或商标',
    name276: '生产厂及地址',
    name277: '生产日期/制造日期',
    name278: '整车编号',
    name279: '电机编码',
    name280: '驱动方式',
    name281: '最高设计车速',
    name282: '整车质量',
    name283: '电机功率与额定电压',
    name284: '电池类型',
    name285: '长/宽/高（mm/mm/mm）',
    name286: '前后轮中心距（mm）',
    name287: '铭牌固定位置',
    name288: '整车编码位置',
    name289: '建议使用年限',
    name290: '是否用于城市物流或商业租赁等经营性活动',
    name291: '中国强制性产品认证(CCC)证书编号',
    name292: '刻制的整车编码',
    name293: '车辆合格证照片',
    name294: '车辆IOT编号：',
    name295: '整车编号：',
    name296: '最大电流：',
    name297: '电机最高温度：',
    name298: '电池最高温度：',
    name299: 'IoT温度显示偏差值（℃）',
    name300: 'IoT温度显示报警预设值（℃）',
    name301: '控制器温度显示偏差值（℃）',
    name302: '控制器温度显示报警预设值（℃）',
    name303: '电池温度显示偏差值（℃）',
    name304: '电池温度显示报警预设值（℃）',
    name305: '电机温度显示偏差值（℃）',
    name306: '电机温度显示报警预设值（℃）',
    name307: '控制器编号',
    name308: '电池编号',
    name309: '仪表编号',
    name310: '销售状态',
    name311: '已售',
    name312: '未出售',
    name313: '制造日期：',
    name314: 'CCC证书编号：',
    name315: '证书截止日期：',
    name316: '产品合格证编号：',
    name317: '车辆制造商：',
    name318: '生产企业名称：',
    name319: '车辆中文商标：',
    name320: '车辆英文商标：',
    name321: '生产企业地址：',
    name322: '长宽高（mm）：',
    name323: '装配完成的电动自行车的整车质量（kg）：',
    name324: '最高设计车速（km/h）:',
    name325: '铭牌固定位置：',
    name326: '车架上整车编码的位置：',
    name327: '续航里程（km）：',
    name328: '车辆外形简图名称：',
    name329: '电池类型：',
    name330: '电池生产企业：',
    name331: '电池容量（Ah）：',
    name332: '电池型号：',
    name333: '电池重量（kg）：',
    name334: '电池长宽高（mm）：',
    name335: '前后轮中心距（mm）：',
    name336: '驱动方式：',
    name337: '百公里电耗（Wh）：',
    name338: '电机生产企业：',
    name339: '电机型号：',
    name340: '电机型式：',
    name341: '电机额定转速：',
    name342: '电机额定电压（V）：',
    name343: '电机额定连续输出功率（W）：',
    name344: '控制器生产企业：',
    name345: '控制器型号：',
    name346: '控制器欠压保护值（V）：',
    name347: '控制器过流保护值（A）：',
    name348: '前轮轮胎规格：',
    name349: '后轮轮胎规格：',
    name350: '执行标准号：',
    name351: '载重量（kg）：',
    name352: '电池标称电压（V）：',
    name353: '电机标称功率（W）：',
    name354: '刹车类型：',
    name355: '变速器规格：',
    name356: 'IOT生产企业：',
    name357: '编辑车型',
    name358: '中国强制性产品认证(CCC)证书编号：',
    name359: 'CCC证书状态：',
    name360: '长（mm）：',
    name361: '宽（mm）：',
    name362: '高（mm）：',
    name363: '电池长（mm）：',
    name364: '电池宽（mm）：',
    name365: '电池高（mm）：',
    name366: '产品型号：',
    name367: '生产时间：',
    name368: '销售状态：',
    name369: 'CCC物料导出',
    name370: '车辆证件信息',
    name371: '车辆参数信息',
    name372: '合格证照片：',
    name373: '其他照片：',
    name374: 'IOT型号：',
    name375: '报警时间',
    name376: 'IOT软件版本号',
    name377: 'IOT硬件版本号',
    name378: '偏移值',
    name379: '测试车辆：',
    name380: '请选择车辆',
    name381: '是否删除该车辆？',
    name382: '最多选择一辆车辆',
    name383: '此操作将改变运输模式,是否继续？',
    name384: '是否解绑车型？',
    name385: '解绑成功!',
    name386: '已取消解绑',
    name387: '导入IOT信息',
    name388: '五通码信息导入成功',
    name389: '导入IOT信息失败',
    name390: '导入五通码信息',
    name391: '导入IOT信息成功',
    name392: '请选择厂商和附件',
    name393: '导入合格证信息成功',
    name394: '导入合格证信息失败',
    name395: '导入合格证信息',
    name396: '导入车辆信息成功',
    name397: '导入车辆信息失败',
    name398: '导入车辆信息',
    name399: '导入车辆出厂信息失败',
    name400: '导入车辆出厂信息',
    name401: '导入车辆出厂信息成功',
    name402: '修改车辆出厂信息',
    name403: '车辆出厂信息EXCEL上传：',
    name404: '车辆信息EXCEL上传：',
    name405: '产品质量合格证EXCEL上传：',
    name406: '运营商名称：',
    name407: '车型偏移',
    name408: '车型EXCEL上传：',
    name409: '车辆生产信息',
    name410: '合格证图片',
    name411: '有线升级',
    name412: 'APP升级',
    name413: '仪表',
    name414: '离线',
    name415: '升级中',
    name416: '成功',
    name417: '失败',
    name418: '升级包下载失败',
    name419: '升级包校验错误及外部设备通讯故障',
    name420: '过压保护',
    name421: '欠压保护',
    name422: '控制器功率管损坏或过流故障',
    name423: '堵转保护',
    name424: '电机霍尔故障',
    name425: '电机相线故障',
    name426: '转把电压过高',
    name427: '控制器/电机过温保护',
    name428: '控制器电压故障',
    name429: '异常助力故障',
    name430: 'MCU自检故障',
    name431: '飞车保护',
    name432: '踏板传感器故障',
    name433: '速度传感器故障',
    name434: '刹把故障',
    name435: '超速',
    name436: '电池通讯故障',
    name437: '电池过温',
    name438: '仪表通讯故障',
    name439: '客户端编号',
    name440: '订阅数',
    name441: 'IP地址',
    name442: '连接状态',
    name443: '已连接',
    name444: '未连接',
    name445: 'OTA来源：',
    name446: 'MAC地址：',
    name447: '车辆调试报告',
    name448: '添加OTA文件',
    name449: '编辑OTA文件',
    name450: '维修单号',
    name451: '操作人',
    name452: '门店地址',
    name453: '维修时间',
    name454: '维修类型',
    name455: '更换前编号',
    name456: '更换后编号',
    name457: '维修图片',
    name458: '销售时间',
    name459: '发票图片',
    name460: '修改车辆出厂信息失败',
    name461: '修改车辆出厂信息成功',
    name462: '产品认证(CCC)证书信息',
    name463: '厂商未绑定车型，无法准确识别控制器偏移值，可能导致部分数据结果有误差。请厂商前往车型管理添加车型，并为车辆绑定车型。',
    name464: 'IOT编号不存在',
    name465: '开始时间点',
    name466: '结束时间点',
    name467: '维修类型：',
    name468: '请输入车型编号',
    name469: '请选择运营商',
    name470: '请选择版本号',
    name471: '请选择类型',
    name472: '请填写车型编号',
    name473: '请输入IOT编号',
    name474: '请输入车型名称',
    name475: '请输入CCC证书编号',
    name476: '请选择厂商',
    name477: '请选择开始时间',
    name478: '请选择结束时间',
    name479: '请输入MAC地址',
    name480: '请选择车型编号',
    name481: '请选择商户',
    name482: '请选择文件',
    name483: '请选择时间',
    name484: '请选择六个小时内的时间',
    name485: '行驶距离(m)',
    name486: '持续时间(s)',
    name487: '开始时间',
    name488: '结束时间',
    name489: '详情轨迹',
    name490: '维修时间：',
    name491: '销售时间：',
    name492: '车辆MAC号：',
    name493: '设备归属：',
    name494: '锁车状态：',
    name495: '(负值为电池充电)',
    name496: '北斗定位状态',
    name497: '查看数据源',
    name498: '数据上传时间点',
    name499: '电池电量',
    name500: '海拔高度',
    name501: '北斗速度(KM/h)',
    name502: '定位数据来源',
    name503: '电池温度(℃)',
    name504: '电池电压(V)',
    name505: '电池电流(A)',
    name506: '电池充电状态',
    name507: '功率(W)',
    name508: '总里程(KM)',
    name509: '踏频',
    name510: '故障码',
    name511: '故障码文字说明',
    name512: '子单体电池包总数',
    name513: '单体电池包{num}电压(V)',
    name514: '开机',
    name515: '关机',
    name516: '防盗开启',
    name517: '充电中',
    name518: '北斗',
    name519: '基站',
    name520: '充电',
    name521: '放电',
    name522: '速度(KM/h)',
    name523: '控制器温度(℃)',
    name524: '电机温度(℃)',
    name525: '经度(°)',
    name526: '纬度(°)',
    name527: '充电器型号：',
    name528: '充电器执行标准：',
    name529: '整车出厂信息导出',
    name530: '整车出厂信息',
    name531: 'IOT重置',
    name532: '重置成功',
    name533: '短信配置',
    name534: '平台配置',
    name535: '模板管理',
    name536: '短信平台',
    name537: '地域',
    name538: '每天最大发送次数',
    name539: '次',
    name540: '新增模板',
    name541: '业务场景',
    name542: '模板CODE',
    name543: '模板原文',
    name544: '状态',
    name545: '测试发送',
    name546: '保存配置',
    name547: '阿里云',
    name548: 'AccessKey ID',
    name549: 'AccessKey Secret',
    name550: '编辑模板',
    name551: '手机号',
    name552: '发送',
    name553: '请选择模板',
    name554: '验证码',
    name555: '电量预警',
    name556: '模板名称',
    name557: '签名CODE',
    name558: '签名名称',
    name559: '启用状态',
    name560: '启用',
    name561: '系统预设（不可改）',
    name562: '禁用',
    name563: '参数个数',
    name564: '是否删除该模板？',
    name565: '参数',
    name566: '添加参数',
    name567: '请先完善平台配置必填项',
    name568: '多个编号请用;隔开',
    name569: '查看导入记录',
    name570: '上传时间',
    name571: 'EXcel',
    name572: '下载',
    name573: '单独蓝牙',
    name574: '五通码模板下载：',
    name575: '五通码EXCEL上传：',
    name576: '五通码上传',
    name577: '列配置',
    name578: '修改车辆基本信息',
    name579: '是否对 IOT {ebikeId} 进行重置操作？',
    name580: '全选',
    name581: '保存',
    name582: '无故障',
    name583: '电量不足',
    name584: '请选择同一厂商和同一车型编号的数据',
    name585: '该车辆已经存在',
    name586: '充电器厂家：',
    name587: '充电器唯一性编号：',
    name588: '远程启用',
    name589: '远程停用',
    name590: '解锁电池',
    name591: '锁定电池',
    name592: '擦除',
    name593: '更多操作',
    name594: 'IOT {ebikeId} "{action}" 成功',
    name595: 'IOT {ebikeId} 操作失败',
    name596: 'IOT {ebikeId} 操作超时,请重试',
    name597: '正在处理中,请稍候...',
    name598: '该车辆正在处理中,请等待完成',
    name599: '是否要对车辆 {ebikeId} 进行"{action}"操作吗？',
    name601: '远程锁定中',
    name603: '开启远程锁定',
    name604: '关闭远程锁定',
    name605: 'IOT {ebikeId} 数据没有擦除成功',
    name606: 'IOT {ebikeId} "{action}" 失败',
    name607: '锁车状态',
    name608: 'IOT {ebikeId} 数据擦除成功',
    name609: '是否擦除 IOT {ebikeId} 配件数据？',
    name610: '擦除',
    modelExample: {
      ebikeModelId: '请输入如：KX202504290012',
      ebikeModelName: '请输入如：公路车1号',
      cccCode: '请输入如：2025011119001230',
      modelColor: '请输入如：黑色',
      iotVersionNo: '请输入如：IOT001',
      controllerVersion: '请输入如：KZQ011',
      batteryVersion: '请输入如：DC011',
      motorVersion: '请输入如：DJ011',
      meterVersion: '请输入如：YB001',
      certificateExpireDate: '请输入如：2026-7-23',
      productModel: '请输入如：LL123421',
      productCertificateNumber: '请输入如：A149878RS11000000',
      certificateStatus: '请输入如：有效',
      ebikeManufacturer: '请输入如：溧电车辆制造商公司',
      manufactureEnterpriseName: '请输入如：凤凰自行车生产企业公司',
      ebikeCnBrand: '请输入如：不适用',
      ebikeEnBrand: '请输入如：leadeercloud',
      manufactureEnterpriseAddress: '请输入如：江苏省南通市太平区武进街道',
      lengthValue: '请输入如：1260',
      widthValue: '请输入如：540',
      heightValue: '请输入如：1056',
      ebikeWeight: '请输入如：20',
      maxDesignSpeed: '请输入如：25',
      nameplateFixedPosition: '请输入如：铆接在车架下管前部',
      ebikeFrameCodePosition: '请输入如：字高：6mm字深0.2mm 分上下两排，刻印在车架上。',
      enduranceMileage: '请输入如：40',
      ebikeOutlinePicName: '请输入如：公路车',
      batteryType: '请输入如：锂电',
      batteryManufactureEnterpriseName: '请输入如：宁德电池生产公司',
      batteryCapacity: '请输入如：10.4',
      batteryModel: '请输入如：10S4P',
      batteryVoltage: '请输入如：36',
      batteryCurrent: '请输入如：10A',
      batteryWeight: '请输入如：2.5±0.5',
      batteryLength: '请输入如：257',
      batteryWidth: '请输入如：78',
      batteryHeight: '请输入如：94',
      chargerModel: '请输入如：DZL4830-01-SS',
      chargerStandards: '请输入如：GB42296-2022',
      chargerManufactureEnterpriseName: '请输入如：深圳南山充电器制造公司',
      beforeAfterWheelDistance: '请输入如：910',
      driveType: '请输入如：电驱动和电助动',
      hundredKmPowerConsumption: '请输入如：480',
      motorManufactureEnterprise: '请输入如：上海电机公司',
      electricalMachineryModel: '请输入如：JNW90-14',
      motorType: '请输入如：永磁',
      motorRatedSpeed: '请输入如：420±10',
      motorRatedVoltage: '请输入如：36',
      motorRatedOutputPower: '请输入如：250',
      controllerManufactureEnterprise: '请输入如：南京科桥电气有限公司',
      controllerModel: '请输入如：90B',
      controllerUndervoltageProtectionValue: '请输入如：30.0±1',
      controllerOvercurrentProtectionValue: '请输入如：15.0±1',
      frontTireSpecifications: '请输入如：26*1.95',
      rearTireSpecifications: '请输入如：26*1.95',
      executiveStandardNumber: '请输入如：GB 17761-2018',
      deadweightCapacity: '请输入如：150',
      batteryNominalVoltage: '请输入如：50V',
      motorNominalPower: '请输入如：10W',
      brakeType: '请输入如：碟刹',
      transmissionSpecifications: '请输入如：TX32',
      iotManufactureEnterprise: '请输入如：南京溧水电子研究所有限公司',
      sensor: '请输入如：中轴力矩传感器',
    },
  },
  finance: {
    name1: '商户名称：',
    name2: '账单时间：',
    name3: '付款状态：',
    name4: '手动生成账单',
    name5: '账单生成设置',
    name6: '账单时间',
    name7: '厂商>商户名称',
    name8: '车辆数量',
    name9: '单价（$）',
    name10: '总计（$）',
    name11: '备注',
    name12: '付款状态',
    name13: '付款凭证',
    name14: '付款时间',
    name15: '操作',
    name16: '编辑',
    name17: '编辑付款情况',
    name18: '厂商>商户名称：',
    name19: '账单生成时间：',
    name20: '备注：',
    name21: '付款时间：',
    name22: '付款凭证上传：',
    name23: 'IOT设备采购订单：',
    name24: '有效时间：',
    name25: '车辆名称：',
    name26: 'IMSI：',
    name27: 'SIM卡编号：',
    name28: 'IOT编号',
    name29: 'IMSI',
    name30: 'SIM卡编号',
    name31: '创建时间',
    name32: '详情',
    name33: 'IOT编号：',
    name34: 'SIM卡剩余流量信息',
    name35: '（总流量：',
    name36: '）',
    name37: '已使用流量',
    name38: '剩余流量',
    name39: '厂商>商户：',
    name40: '厂商>商户',
    name41: '请选择订单状态',
    name42: '请输入订单编号',
    name43: '请选择车型名称',
    name44: '订单状态：',
    name45: '订单时间：',
    name46: '订单开始时间',
    name47: '订单结束时间',
    name48: '数量',
    name49: '商户名称',
    name50: '车型编号',
    name51: '电子合同上传：',
    name52: '修改厂商购车订单状态',
  },

  operate: {
    name1: '商户名称：',
    name2: '搜索：',
    name3: 'app编号',
    name4: '厂商名称',
    name5: 'app名称',
    name6: 'app图标',
    name7: '版本号',
    name8: '最近上线时间',
    name9: '操作',
    name10: '版本列表',
    name11: '新增',
    name12: '版本号：',
    name13: '版本状态：',
    name14: '序号',
    name15: '版本编号',
    name16: '版本号',
    name17: '版本类型',
    name18: '更新类型',
    name19: '版本状态',
    name20: '发布时间',
    name21: '更新时间',
    name22: '操作',
    name23: '状态',
    name24: '修改',
    name25: '删除',
    name26: '填写版本信息',
    name27: '版本描述：',
    name28: '版本类型：',
    name29: '更新类型：',
    name30: '可忽略',
    name31: '正常',
    name32: '强制',
    name33: '文件：',
    name34: '点击上传',
    name35: '版本描述：',
    name36: '修改版本状态',
    name37: '版本号：',
    name38: '状态：',
    name39: '禁用',
    name40: '测试',
    name41: '发布',
    name42: '登录账号',
    name43: '商户类型',
    name44: '昵称',
    name45: '用户编号',
    name46: '头像',
    name47: '注册时间',
    name48: '启用',
    name49: '关联车辆',
    name50: '重置密码',
    name51: '电子围栏名称：',
    name52: '离开时间：',
    name53: '电子围栏名称',
    name54: '离开时间≥5分钟',
    name55: '进入时间',
    name56: '累加出入时间',
    name57: '轨迹详情',
    name58: '围栏编号：',
    name59: '围栏名称：',
    name60: '围栏类型：',
    name61: '围栏编号',
    name62: '围栏名称',
    name63: '围栏类型',
    name64: '绘制类型',
    name65: '活动区域',
    name66: '禁止区域',
    name67: '多边形',
    name68: '坐标点编辑',
    name69: '新增区域围栏',
    name70: '编辑区域围栏',
    name71: '绘制类型：',
    name72: '地图类型：',
    name73: '谷歌地图',
    name74: '天地图地图',
    name75: '轨迹速度',
    name76: '开始',
    name77: '路径回放',
    name78: '暂停回放',
    name79: '电子围栏-车辆列表',
    name80: '搜索',
    name81: '导入',
    name82: 'IOT添加',
    name83: '电子围栏-车辆列表导入',
    name84: '轨迹速度：',
    name85: '坐标保存成功！',
    name86: '订单编号：',
    name87: '用户编号：',
    name88: '流水号：',
    name89: '支付平台：',
    name90: '时间：',
    name91: '订单编号',
    name92: '流水号',
    name93: '用户编号',
    name94: '交易金额',
    name95: '支付平台',
    name96: '交易凭证',
    name97: '交易时间',
    name98: '全部',
    name99: '支付宝',
    name100: '微信',
    name101: '贝宝',
    name102: '申请编号：',
    name103: '申请者编号：',
    name104: '审核状态：',
    name105: '申请编号',
    name106: '申请者编号',
    name107: '退款金额',
    name108: '申请时间',
    name109: '申请状态',
    name110: '申请结果',
    name111: '详情',
    name112: '复审',
    name113: '初审',
    name114: '退款原因',
    name115: '审核编号：',
    name116: '申请时间：',
    name117: '审核人员ID：',
    name118: '审核时间：',
    name119: '审核原因：',
    name120: '审核结果：',
    name121: '退款凭证（图片）',
    name122: '退款详情',
    name123: ' 审核信息',
    name124: '改操作讲进行复审的流程？',
    name125: '改操作讲进行初审的流程？',
    name126: '停车区域',
    name127: 'App编号：',
    name128: 'App名称：',
    name129: '商户列表',
    name130: '新增版本',
    name131: '提交人姓名：',
    name132: '反馈标题：',
    name133: '反馈状态：',
    name134: '提交人',
    name135: '反馈标题',
    name136: '反馈地点',
    name137: '反馈者邮箱',
    name138: '反馈时间',
    name139: '反馈状态',
    name140: '定制App信息',
    name141: '个人通用App信息',
    name142: '添加APP信息',
    name143: '编辑APP信息',
    name144: 'app图标：',
    name145: '添加通用个人APP商户',
    name146: '电商中心',
    name147: '用户须知',
    name148: '隐私条款',
    name149: 'logo设置',
    name150: '预览',
    name151: '电商网址：',
    name152: '用户须知预览',
    name153: '隐私条款预览',
    name154: '请输入链接地址',
    name155: '登录名/Email',
    name156: '昵称',
    name157: '账号类型',
    name158: '用户编号',
    name159: '手机号',
    name160: '联接时间',
    name161: '解除绑定',
    name162: '推送消息',
    name163: '推送信息：',
    name164: '新密码：',
    name165: '确认新密码：',
    name166: '路书编辑',
    name167: '路书使用',
    name168: '骑行模式',
    name169: '寻车',
    name170: '报警设置',
    name171: '请选择区域',
    name172: '请输入围栏名称',
    name173: '请选择围栏类型',
    name174: '请选择绘制类型',
    name175: '请选择IOT编码',
    name176: '反馈内容',
    name177: '反馈图片',
    name178: '版本名：',
    name179: '下载页链接',
    name180: '复制下载页链接',
    name181: '版本名',
    name182: '继续回放',
    name183: '请输入app编码',
    name184: '请选择app图标',
    name185: '请输入app名称',
    name186: '请选择状态',
    name187: '请输入版本名',
    name188: '复制成功',
    name189: '复制失败',
    name190: '提交成功!',
    name191: '推送编号',
    name192: '发送者编号',
    name193: '消息类型',
    name194: '业务编码',
    name195: '消息编码',
    name196: '消息时间',
    name197: '内容',
    name198: '文本',
    name199: '请输入版本号',
    name200: '建议尺寸：200*200px，最多上传1张',
    name201: '请联系溧电，为您创建APP',
    name202: '出入电子围栏日志',
    name203: '配置',
    name204: '暂无App信息',
    name205: 'App下载',
  },

  manage: {
    name1: '搜索：',
    name2: '状态：',
    name3: '新增用户',
    name4: '登录账号',
    name5: '用户名',
    name6: '角色',
    name7: '电话',
    name8: '邮箱',
    name9: '最近编辑时间',
    name10: '最后一次登录时间',
    name11: '最后一次登录ip',
    name12: '状态',
    name13: '启用',
    name14: '禁用',
    name15: '操作',
    name16: '绑定角色',
    name17: '编辑',
    name18: '删除',
    name19: '添加系统用户',
    name20: '登录账号：',
    name21: '密码：',
    name22: '姓名：',
    name23: '昵称：',
    name24: '电话：',
    name25: '角色：',
    name26: '邮箱：',
    name27: '角色名称：',
    name28: '角色名称',
    name29: '权限',
    name30: '新增角色',
    name31: '添加身份',
    name32: '身份名称：',
    name33: '是否开启：',
    name34: '开启',
    name35: '关闭',
    name36: '权限：',
    name37: '权限名称：',
    name38: '权限名称',
    name39: '接口路径',
    name40: '前端权限',
    name41: '页面路由',
    name42: '子菜单',
    name43: '添加规则',
    name44: '类型：',
    name45: '接口',
    name46: '菜单',
    name47: '接口中文名称：',
    name48: '父级分类：',
    name49: '新增权限',
    name50: '请求方法：',
    name51: '接口地址：',
    name52: '路由地址：',
    name53: '权限标识：',
    name54: '排序：',
    name55: '图标：',
    name56: '注:上传图标，200*200像素。只能上传一张',
    name57: '隐藏菜单：',
    name58: '时间：',
    name59: '时间',
    name60: '导出',
    name61: '操作账号id',
    name62: '操作账号',
    name63: '操作类型',
    name64: '操作内容',
    name65: '厂商名称：',
    name66: '厂商编码',
    name67: '厂商名称',
    name68: '创建时间',
    name69: '厂商订购数量',
    name70: '车型数量',
    name71: '关联商户数量',
    name72: '联系方式',
    name73: '厂商账号',
    name74: '添加',
    name75: '厂商编码：',
    name76: '联系人：',
    name77: '联系方式：',
    name78: '备注：',
    name79: '商户名称',
    name80: '商户类型',
    name81: '商户用户数量',
    name82: '备注',
    name83: 'IOT收费状态',
    name84: '商户账号',
    name85: '添加商户名单',
    name86: '商户名称：',
    name87: '商户类型：',
    name88: '进入',
    name89: '添加商户用户',
    name90: '加盟商名称：',
    name91: '加盟商名称',
    name92: '商户车辆数量',
    name93: '加盟商账号',
    name94: '编辑系统用户',
    name95: '菜单中文名称：',
    name96: '编辑身份',
    name97: '添加厂商名单',
    name98: '编辑厂商名单',
    name99: '添加厂商用户',
    name100: '编辑厂商用户',
    name101: '编辑商户用户',
    name102: '添加加盟商用户',
    name103: '编辑加盟商用户',
    name104: '接口英文名称：',
    name105: '菜单英文名称：',
    name106: '所有权限',
    name107: '平台：',
    name108: '厂商App',
    name109: '客服类型：',
    name110: '内容：',
    name111: '网站与账号',
    name112: '账号名称：',
    name113: '网址：',
    name114: '名称：',
    name115: '权限配置',
    name116: '溧电',
    name117: '厂商',
    name118: '品牌商户',
    name119: '品牌商户加盟商',
    name120: '共享商户',
    name121: '租赁商户',
    name122: '共享加盟商',
    name123: '租赁加盟商',
    name124: 'H5权限',
    name125: '管理后台',
    name126: '是否删除该用户？',
    name127: '是否禁厂商App权限？',
    name128: '是否启用厂商App权限？',
    name129: '售车商户',
    name130: '详细地址',
    name131: '联系电话',
    name132: '详细地址：',
    name133: '联系电话：',
    name134: '门牌号，例如：1层102室',
    name135: '添加加盟商名单',
    name136: '编辑加盟商名单',
    name137: '是否删除该加盟商？',
    name138: '加盟商',
    name139: '车间APP',
    name140: '是否禁车间App权限？',
    name141: '是否启用车间App权限？',
  },

  public: {
    name1: '请选择',
    name2: '商户类型',
    name3: '查询',
    name4: '重置',
    name5: '请输入',
    name6: '选择日期时间',
    name7: '退出登录',
    name8: '溧电云物联网平台',
    name9: '至',
    name10: '开始日期',
    name11: '结束日期',
    name12: '上传',
    name13: '提交',
    name14: '取消',
    name15: '开始月份',
    name16: '结束月份',
    name17: '发送成功',
    name18: '修改成功',
    name19: '全部',
    name20: '开启',
    name21: '关闭',
    name22: '注销',
    name23: '提示',
    name24: '确定删除当前数据？',
    name25: '确定',
    name26: '确认密码：',
    name27: '邮箱格式不正确',
    name28: '请输入昵称或账号',
    name29: '请输入如：',
    name30: '删除成功!',
    name31: '已取消删除',
    name32: '是否确定提交？',
    name33: '已取消提交',
    name34: '已取消',
    name35: '上传中，请稍候...',
    name36: '上传的文件大小不能超过10MB!',
    name37: '下载查看失败原因',
    name38: '请选择附件',
    name39: '暂无数据',
    name40: '您确定删除该条数据吗？',
    name41: '添加成功',
    name42: '上传成功',
    name43: '选择日期',
    name44: '加载中...',
    name45: '请选择任意一级',
    name46: '导入车型信息失败？',
    name47: '车型导入信息',
    name48: '导入车型信息成功',
    name49: '最近6小时',
    name50: '最近1小时',
    name51: '最后登录时间',
    name52: '确定删除当前车辆？',
    name53: '电子围栏 - 导入IOT信息',
    name54: '定位信息异常',
    name55: '单个电池电压',
    name56: '数据获取时间：',
    name57: '单个电池电压（V）',
    name58: '序号',
    name59: '北斗定位异常',
    name60: '异常',
    name61: '请输入标题',
    name62: '请选择封面图',
    name63: '该骑行没有路径',
    name64: '文件上传成功，请查看下载结果',
    name65: '文件大小不得超过50M',
    name66: '只能上传后缀是.xlsx的文件',
    name67: '文件大小不能超过 1MB!',
    name68: '您确定删除该条路书吗？',
    name69: '请选择图片',
    name70: '请先选择串口',
    name71: '打开串口失败',
    name72: '发送内容为空',
    name73: '请先打开串口再发送数据',
    name74: '当前限制选择 1 个文件',
    name323: '该整车编号不存在或未绑定厂商，无法提交',
  },

  account: {
    name1: '修改邮箱',
    name2: '用户自定义消息',
    name3: '用户自定义时区',
    name4: '确定',
    name5: '我的账号',
    name6: '语言切换',
    name7: '请输入新的邮箱',
    name8: '确认',
    name9: '取消',
    name10: '简体中文',
    name11: '英文',
    name12: '我的',
    name13: '暂无销售记录',
    name14: '添加销售记录',
    name15: '暂无维修记录',
    name16: '添加维修记录',
    name17: '扫码识别',
    name18: '销售时间',
    name19: '上传发票',
    name20: '是否提交销售记录？',
    name21: '请点击右上角三个点，然后再点击重新进入小程序，拍照识别时请点击允许申请使用摄像头',
    name22: '请输入整车编号',
    name23: '查看发票',
    name24: '没有更多数据了',
    name25: '编号',
    name26: '维修现场照片',
    name27: '（最多添加9张）',
    name28: '编号：',
    name29: '用户登录',
    name30: '您好,欢迎登录',
    name31: '请输入手机号码/邮箱',
    name32: '注册账号',
    name33: '切换',
    name34: '手机号注册',
    name35: '邮箱注册',
    name36: '姓名',
    name37: '昵称',
    name38: '门店地址',
    name39: '返回登录',
    name40: '同意并阅读',
    name41: '《用户协议与隐私政策》',
    name42: '用户协议与隐私政策',
    name43: '设置登录密码',
    name44: '设置密码后，您可以使用新密码登录',
    name45: '手机号',
    name46: '邮箱',
    name47: '修改时区',
    name48: '请勾选用户协议与隐私政策',
    name49: '时区不一致',
    name50: '您本机时区为「{browser}」，与设定中的用户自定义时区「{account}」不一致，可能影响时间显示与查询结果。请前往「设定」调整时区，或将本机时区改为与账号一致。',
  },
  screen: {
    name1: '定位',
    name167: '车辆分布围栏',
    name169: '坐标',
    name170: '经度',
    name171: '纬度',
    name110: '操作',
    name111: '修改',
    name112: '删除',
    name168: '保存',
    name79: '取消',
    name95: '添加',
    name172: '保存坐标系',
    name173: '请先保存编辑过后的坐标',
    name174: '新坐标',
    name175: '请先保存编辑过后的坐标',
    name2: '标题：',
    name3: '标题',
    name4: '苏ICP备2023025954号-3',
    name5: '请输入推送信息',
    name6: '请输入新密码',
    name7: '请再次输入新密码',
    name8: '请输入账号',
    name9: '您确定解绑该车辆吗？',
    name10: '密码修改成功',
    name11: '请选择需要推送的用户',
    name12: '推送成功',
    name13: '地点：',
    name14: '是否删除该账号？',
    name15: '请输入厂商名称',
    name16: '是否删除该厂商？',
    name17: '是否禁该厂商？',
    name18: '是否启用该厂商？',
    name19: '请输入身份名称',
    name20: '请选择是否开启',
    name21: '管理员',
    name22: '业务员',
    name23: '是否删除该角色？',
    name24: '请选择平台',
    name25: '请选择角色',
    name26: '请搜索选择地址',
    name27: '请输入联系电话',
    name28: '请输入加盟商名称',
    name29: '请选择加盟商',
    name30: '请输入商户名称',
    name31: '请选择地址',
    name32: '请选择商户类型',
    name33: '是否禁该商户？',
    name34: '是否启用该商户？',
    name35: '一级',
    name36: '二级',
    name37: '三级',
    name38: '按钮',
    name39: '请输入菜单中文名称',
    name40: '请输入菜单英文名称',
    name41: '请输入路由地址',
    name42: '是否删除此条数据？',
    name43: '是否禁用此权限规则？',
    name44: '是否启用此权限规则？',
    name45: '系统日志',
    name46: '修改手机号',
    name47: '请输入新的手机号码',
    name48: '邮箱修改成功',
    name49: '手机号修改成功',
    name50: '新提出',
    name51: '已查阅',
    name52: '处理中',
    name53: '已拒绝',
    name54: '已关闭',
    name55: '反馈详情',
    name230: '添加坐标点',
    name322: '该卡片未激活',
  },
  apiMessage: {
    name1: 'IOT编号不得超2000字符',
    name2: 'iot未入库',
    name3: 'iot未入库!',
    name4: 'iot编号已经存在!',
    name5: 'mac地址已经存在!',
    name6: '你只有3次分享的机会!',
    name7: '你好，获取验证码失败。该电动自行车已被其他用户绑定!',
    name8: '你无权修改!',
    name9: '你无权修改该车辆!',
    name10: '你无权删除该车辆!',
    name11: '你无权删除该骑行记录!',
    name12: '你无权去修改!',
    name13: '你无权去操作!',
    name14: '你无权去操作该路书!',
    name15: '你无权操作该路书!',
    name16: '你无权操作该车辆!',
    name17: '你无权查看！',
    name18: '你无权访问该车辆!',
    name19: '你无权访问该车辆！',
    name20: '你无权访问车辆!',
    name21: '你无法访问该车辆！',
    name22: '你无该车辆！',
    name23: '你没有权限操作该车辆!',
    name24: '信息修改失败！',
    name25: '共享授权ID为空！',
    name26: '共享授权不存在！',
    name27: '共享验证无效，无法禁用！',
    name28: '删除共享授权失败！',
    name29: '历史骑行记录不能为空!',
    name30: '反馈信息不存在!',
    name31: '反馈状态设置不正确！',
    name32: '取消防盗超时!',
    name33: '围栏并不存在！',
    name34: '围栏根本不存在！',
    name35: '围栏点不能为空！',
    name36: '围栏车辆不存在！',
    name37: '围栏车辆已经存在！',
    name38: '固件不存在！',
    name39: '固件信息不存在!',
    name40: '头部错误!',
    name41: '存在子菜单，不可删除',
    name42: '存在角色和菜单绑定，不可删除',
    name43: '密码必须包含数字，大小写字母和特殊符号且长度大于8位',
    name44: '已有重复数据!',
    name45: '开启防盗超时!',
    name46: '微信小程序获取授权信息失败！',
    name47: '您不能朝着该车辆!',
    name48: '您无权查看骑行轨迹!',
    name49: '您无法进入该车辆！',
    name50: '您无法进入车辆!',
    name51: '报头错误！',
    name52: '按钮类型的权限表示不能为空',
    name53: '数据异常!',
    name54: '整车编号已存在',
    name55: '文件名称过长！',
    name56: '无操作权限！',
    name57: '无权修改此围栏！',
    name58: '无权删除此围栏！',
    name59: '无权访问!',
    name60: '无权访问！',
    name61: '无此操作权限',
    name62: '无法获取绑定信息。您输入的电话号码与预设电话号码不匹配!',
    name63: '未找到分页数据!',
    name64: '未检测到Excel数据！',
    name65: '权限不足！',
    name66: '标题错误！',
    name67: '此版本号已存在，请重新填写！',
    name68: '用户车辆不存在！',
    name69: '用户骑行不存在！',
    name70: '电动自行车已经存在!',
    name71: '短信注册今日已达上限，请明日再试!',
    name72: '禁用共享验证失败！',
    name73: '租户不存在！',
    name74: '租户信息不存在!',
    name75: '系统异常!',
    name76: '系统菜单id不能为空',
    name77: '系统菜单不存在',
    name78: '获取微信小程序用户信息失败！',
    name79: '获取微信小程序用户手机号失败！',
    name80: '菜单类型的组件路径不能为空',
    name81: '表头错误！',
    name82: '角色名称重复',
    name83: '解锁超时!',
    name84: '该围栏不存在！',
    name85: '该忽略请求不存在，无法忽略!',
    name86: '该联系人不存在！',
    name87: '该联系人已经存在！',
    name88: '该账号并未绑定手机号',
    name89: '该路书不存在!',
    name90: '该车型不存在!',
    name91: '该车辆不存在!',
    name92: '该车辆不存在，请确认!',
    name93: '该车辆不属于你！',
    name94: '该车辆已经存在!',
    name95: '该车辆当前正在被使用!',
    name96: '该车辆当前正在被锁定，请稍后再试试!',
    name97: '该车辆正在被使用!',
    name98: '该车辆编号不能为空!',
    name99: '请先输入车型信息！',
    name100: '请填写设置信息!',
    name101: '请正确输入参数!',
    name102: '请选择一辆车！',
    name103: '请选择厂商！',
    name104: '请选择并输入维修信息！',
    name105: '读取EXCEL失败，请检查文件格式是否异常!',
    name106: '读取EXCEL失败，请检查文件格式是否异常！',
    name107: '调用查询流量接口失败！',
    name108: '路书不存在!',
    name109: '车型不存在!',
    name110: '车型不存在！',
    name111: '车型信息不存在！',
    name112: '车型编号已存在!',
    name113: '车辆不在线!',
    name114: '车辆不存在!',
    name115: '车辆不存在！',
    name116: '车辆不存在，请确认!',
    name117: '车辆信息不存在!',
    name118: '车辆信息不存在！',
    name119: '车辆信息已存在!',
    name120: '车辆信息已存在！',
    name121: '车辆关锁超时!',
    name122: '车辆已经被其他人绑定!',
    name123: '车辆未找到!',
    name124: '车辆编号不存在！',
    name125: '车辆编号不能为空！',
    name126: '车辆调试报告不存在！',
    name127: '返回的用户不存在!',
    name128: '进入运输模式超时！',
    name129: '问题不存在!',
    name130: '问题反馈不存在！',
    name131: '骑行编号不正确!',
    name132: '骑行编号不能为空!',
    name133: '操作成功',
    name134: '操作失败',
    name135: '参数不正确',
    name136: '参数检验失败',
    name137: '未登录或token过期，请登录！',
    name138: '用户缓存已过期，请清除缓存重新登录',
    name139: '没有相关权限',
    name140: '没有找到相关数据',
    name141: '系统异常',
    name142: 'SQL异常',
    name143: '表头错误！',
    name144: '未检测到Excel数据！',
    name145: '上传的文件对象不存在！',
    name146: '文件目录创建失败！',
    name147: '目标文件创建失败！',
    name148: '文件不存在',
    name149: '允许上传的最大文件为{maxSize}G，当前文件大小为{currentSize}G',
    name150: '该SIM卡在运营商平台不存在！',
    name151: '查询流量数据解析失败！',
    // —— 后端 fail()/BusinessException() 历史未覆盖文案 ——
    name152: '下载临时文件失败！',
    name153: '未绑定车型',
    name154: '未经授权访问！',
    name155: '请选择一个制造商！',
    name156: '车牌号码不能为空！',
  },
  importFailReason: {
    name1: '录入失败,车型名称重复!',
    name2: '录入失败,车型编号不能为空!',
    name3: '录入失败,车辆合格证照片不能为空!',
    name4: '输入失败, 车架号不能为空!',
    name5: '输入失败,, mac不能为空!',
    name6: '输入失败,MAC地址不能为空!',
    name7: '输入失败,MAC地址不能为空!',
    name8: '输入失败,iot 编号不能为空!',
    name9: '输入失败,iot已绑定整车!',
    name10: '输入失败,iot未入库!',
    name11: '输入失败,iot编号不能为空!',
    name12: '输入失败,iot编号不能为空!',
    name13: '输入失败,中国强制性产品认证（CCC）证书编号不能为空!',
    name14: '输入失败,产品名称不能为空!',
    name15: '输入失败,充电器型号超过100个字符!',
    name16: '输入失败,充电器执行标准超过100个字符!',
    name17: '输入失败,制造商或商标不能为空!',
    name18: '输入失败,制造日期格式错误!格式为yyyy-MM-dd!',
    name19: '输入失败,前后轮中心距不能为空!',
    name20: '输入失败,建议使用寿命不能为空!',
    name21: '输入失败,控制器编号不能为空!',
    name22: '输入失败,数据库输入失败!',
    name23: '输入失败,数据库输入失败!',
    name24: '输入失败,整车不能为空!',
    name25: '输入失败,整车信息不存在!',
    name26: '输入失败,整车编号已存在!',
    name27: '输入失败,模型不能为空!',
    name28: '输入失败,物联网不存在!',
    name29: '输入失败,物联网编号不能为空!',
    name30: '输入失败,物联网编号不能为空!',
    name31: '输入失败,物联网编号没有车辆信息!',
    name32: '输入失败,生产工厂和地址不能为空!',
    name33: '输入失败,生产日期/制造日期不能为空!',
    name34: '输入失败,生产日期/制造日期不能为空或格式错误!格式为yyyy-MM-dd!',
    name35: '输入失败,电机功率和额定电压不能为空!',
    name36: '输入失败,电机编号不能为空!',
    name37: '输入失败,电机编号不能为空!',
    name38: '输入失败,电池类型不能为空!',
    name39: '输入失败,电池编号不能为空!',
    name40: '输入失败,证书信息已更改!',
    name41: '输入失败,证书截止日期格式错误!格式为yyyy-MM-dd!',
    name42: '输入失败,证书过期日期格式错误!格式为yyyy-MM-dd!',
    name43: '输入失败,该车辆已绑定至另一份合格证书!',
    name44: '输入失败,请勿修改其他制造商的车辆信息!',
    name45: '输入失败,车型名称不能为空!',
    name46: '输入失败,车型已存在!',
    name47: '输入失败,车型编号不能为空!',
    name48: '输入失败,车型编号不能为空!',
    name49: '输入失败,车型编号重复!',
    name50: '输入失败,车架号不能为空!',
    name51: '输入失败,车辆代码不能为空!',
    name52: '输入失败,车辆代码重复!',
    name53: '输入失败,车辆信息不存在!',
    name54: '输入失败,车辆合格证不能为空!',
    name55: '输入失败,车辆合格证不能为空!',
    name56: '输入失败,车辆型号和名称与预设数据不匹配!',
    name57: '输入失败,车辆编号不能为空!',
    name58: '输入失败,车辆编号不能为空!',
    name59: '输入失败,车辆编号重复!',
    name60: '输入失败,车辆编码不能为空!',
    name61: '输入失败,车辆编码位置不能为空!',
    name62: '输入失败,车辆编码重复!',
    name63: '输入失败,铭牌固定位置不能为空!',
    name64: '输入失败,长宽高不能为空!',
    name65: '输入失败,驾驶模式不能为空!',
    name66: '这些数据已经输入到数据库中,无需再次输入!',
    name67: '输入失败,无法修改此 IoT 信息!',
    name68: '这些数据已经输入到数据库中,无需重新输入!',
    name69: '分配成功!',
    name70: '输入失败,充电器唯一性编号不能为空!',
    name71: '输入失败,充电器厂家不能为空!',
    name72: '输入失败,充电器唯一性编号已存在!',
    name73: '输入失败,充电器厂家超过255个字符!',
    macMismatch: '输入失败,{ebikeId}车辆已存在,但MAC地址不匹配!',
  },
  dataSummary: {
    name1: 'App数量',
    name2: '用户数量',
    name3: '本月新用户数量',
    name4: '管理系统登录情况',
    name5: '系统功能使用情况',
    name6: '系统功能',
  },
  error404: {
    name1: '啊哦~ 你所访问的页面不存在',
    name2: '返回首页',
    name3: '返回上一页',
    name4: '清除登录缓存',
  },
  navTabBar: {
    name1: '用户管理',
    name2: '配置管理',
    name3: '角色管理',
    name4: '定时任务补偿',
  },
  faultStats: {
    name1: '类型1',
    name2: '类型2',
    name3: '今日故障数',
    name4: '昨日',
    name5: '较昨日同期',
    name6: '故障总数',
    name7: '故障统计',
    name8: '全部厂商',
    name9: '商户1',
    name10: '商户2',
    name11: '故障数',
    name12: '导出',
    name13: '故障类型分布',
    name14: '直接访问',
    name15: '市场营销',
    name16: '搜索引擎',
    name17: '邮件营销',
    name18: '联盟广告',
    name19: '视频广告',
    name20: '百度',
    name21: '谷歌',
    name22: '必应',
    name23: '其他',
  },
  map: {
    name1: '损坏',
    name2: '正常可以',
    name3: '时间查询',
    name4: '已认证车辆查询',
    name5: '所有车辆查询',
    name6: '12小时',
    name7: '24小时',
    name8: '36小时',
    name9: '48小时',
    name10: '车辆邮箱',
    name11: 'IOT编号',
    name12: '车锁的状态',
  },
}
